import client from "@/src/apollo/client";
import GenericHead from "@/src/components/Head/GenericHead";
import ContributorCard from "@/src/components/cards/ContributorCard";
import ContentContainer from "@/src/components/containers/ContentContainer";
import { MENU_ITEMS } from "@/src/constants/mocks";
import { GetContributors } from "@/src/gql/queries/contributors";
import { getMenus } from "@/src/gql/queries/nav";
import { ContributorType, NavData } from "@/src/types";
import { Typography } from "@material-tailwind/react";
import { GetStaticProps } from "next";

export interface ContributorsHomeProps {
  contributors: any;
}

const ContributorsHome = ({ contributors }: ContributorsHomeProps) => {
  const contributorsList = contributors.data.contributors.nodes;

  return (
    <>
      <GenericHead title={`SCPB Contributors`} />
      <div className="bg-white h-[100%] flex">
        <ContentContainer minHeight>
          <Typography variant="h1">Contributors</Typography>
          <div className="contianer mx-auto">
            <div className="flex flex-wrap gap-4 p-2">
              {contributorsList.map(function (contributor: ContributorType) {
                return (
                  <ContributorCard
                    contributor={contributor as ContributorType}
                    key={contributor.contributorId}
                  />
                );
              })}
            </div>
          </div>
        </ContentContainer>
      </div>
    </>
  );
};

export const getStaticProps: GetStaticProps = async (context) => {
  const contributors = await client.query({ query: GetContributors });

  return {
    props: { contributors },
  };
};

export default ContributorsHome;
